/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 10:54:00
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import EnumItem from 'src/enums/enumItem';
export declare namespace VideoDOI {
    export interface RowDataI {
        id: number
        name: string
        phone: string
        type: number
        appkey:string
        secret:string
    }

    export interface QueryRowDataParamsI extends PageDo {
        type?: Integer;
    }

    export interface QueryDetailResultI {
        id: number
        name: string
        phone: string
        type: number
        appkey:string
        secret:string
    }

    export interface OperateParamsI {
        id?: Integer
        name:string
        appkey:string
        secret:string
        type: Integer
    }
}
export default class VideoApi {
    /**
     * 查询列表
     * @param {VideoDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: VideoDOI.QueryRowDataParamsI): Promise<ResultPageDo<VideoDOI.RowDataI[]>> {
        return Api.post('/srs_live/query/user/secretkey', {
            type: -2,
            ...params
        });
    }

    /**
     * 查询单个
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(id: number): Promise<Result<VideoDOI.QueryDetailResultI[]>> {
        return Api.post('/srs_live/query/user/secretkey/by_id', { id });
    }


    /**
     * 新增
     * @param {VideoDOI.OperateParamsI type 1萤石云  2乐橙云} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: VideoDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/srs_live/add/user/secretkey', data);
    }


    /**
     * 修改
     * @param {VideoDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: VideoDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/srs_live/edit/user/secretkey', data);
    }


    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(id: number): Promise<Result<any>> {
        return Api.post('/srs_live/delete/user/secretkey', { id });
    }

    /**
     * 查询所有视频密钥
     * @param params 
     */
    static async searchVideoKey(params: VideoDOI.QueryRowDataParamsI): Promise<ResultPageDo<VideoDOI.RowDataI[]>> {
        return Api.post('/srs_live/query/user/secretkey', {
            page_index:1,
            page_size:10000000,
            ...params,
        });
    }
    
}
